import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as adminActions from '../actions/admin-actions';

/**
 * Check if a given Steam key is valid.
 * Returns `true` if valid, `false`, if not.
 */
function isSteamKeyValid(key = '') {
  const match = key.match(/^([A-Za-z0-9]{5}-){2,}([A-Za-z0-9]{5})$/);
  return !!match;
};

class AdminKeyPage extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateKeys = this.updateKeys.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      keyString: '',
      keys: []
    };
  }

  componentDidMount() {
    this.props.actions.requestSteamKeyCount();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.admin.addedKeys) {
      this.updateKeys('');
    }
  }

  handleInputChange(event) {
    const { target } = event;
    const { value, name } = target;

    // Pass the new key string to `updateKeys()` to validate.
    if (name === 'keys') {
      return this.updateKeys(value);
    }

    // Otherwise, just update the state property of `name` with the given `value`.
    this.setState({
      [name]: value
    }, this.validateKeys);
  }

  handleSubmit(ev) {
    ev.preventDefault();

    // Grab valid key list.
    let validKeys = this.state.keys.filter((key) => key.valid);

    // Return early if there are no valid keys (nothing to submit).
    if (!validKeys.length) {
      return;
    }

    console.info('Got', validKeys.length, 'valid keys, submitting...');
    let keyList = validKeys.map((obj) => obj.key);
    this.props.actions.requestAddSteamKeys(keyList);
  }

  /**
   * Update the keys stored on `this.state`. Takes in a new `keyString` and
   * updates `this.state.keys` with a list of key objects, and `this.state.keyString`
   * with the raw string entered by the user.
   *
   * @param {String} keyString The string of comma-delimited keys entered by the user.
   **/
  updateKeys(keyString) {
    // Split the entered `keyString` on commas, filter out any empty strings, and then map it to
    // an array of objects containing a `key` property (the entered key) and a `valid` property
    // (whether or not the entered key is valid).
    let keys = keyString.split(',')
      .filter((str) => !!str.length)
      .map((str) => {
        let key = str.toUpperCase().trim();
        return { key, valid: isSteamKeyValid(key) };
      });

    this.setState({ keys, keyString });
  }

  render() {
    // Wait to show the key count label until we've fetched the details.
    let keyCountLabel = <p>Fetching key details...</p>;
    if (this.props.admin.fetchedKeyCount) {
      // Wrap the label in `.text-warning` if there are no keys left (this means we can't give keys to users!)
      let countClass = '';
      if (this.props.admin.keyCount === 0) {
        countClass = 'text-warning';
      }

      // Render out the label.
      keyCountLabel = <p>Use the form below to add new Steam keys to the Normal backend. <span className={countClass}>We currently have <strong>{this.props.admin.keyCount}</strong> Steam {this.props.admin.keyCount === 1 ? 'key' : 'keys'} available.</span></p>;
    }

    if (this.props.admin.errorFetchingKeyCount) {
      keyCountLabel = <p>Hmm, we couldn't fetch the Steam key count. Are you sure you're supposed to be back here? Reason: {this.props.admin.errorFetchingKeyCount.description}</p>;
    }

    if (this.props.admin.errorAddingKeys) {
      keyCountLabel = <p>Hmm, we couldn't add those keys due to an unknown error from the service:<br /> {this.props.admin.errorAddingKeys.description}</p>;
    }

    if (this.props.admin.addedKeys) {
      keyCountLabel = <p>Successfully added keys! We now have <strong>{this.props.admin.keyCount}</strong> keys available.</p>;
    }

    // Compute the label for showing the data validation state of the inputted Steam keys.
    let enteredKeyCount = this.state.keys.length;
    let invalidKeyCount = this.state.keys.filter((key) => !key.valid).length;
    let validKeyCount = enteredKeyCount - invalidKeyCount;
    let hasValidKeys = validKeyCount > 0;
    let keyInputHelpText;

    if (enteredKeyCount > 0) {
      keyInputHelpText = <p>You've entered {enteredKeyCount ? enteredKeyCount : 'no'} {enteredKeyCount === 1 ? 'key' : 'keys'}, and {invalidKeyCount ? invalidKeyCount : 'none'} of them {invalidKeyCount === 1 ? 'is' : 'are'} invalid. {validKeyCount} {validKeyCount === 1 ? 'key' : 'keys'} will be uploaded.</p>;
    }

    return (
      <div className="AdminKeyPage">
        <h3>Add Steam Keys</h3>
        {keyCountLabel}

        <form className="form" disabled={this.props.admin.addingKeys} onSubmit={this.handleSubmit}>
          <textarea value={this.state.keyString} className="form-input form-input--fullwidth" name="keys" onChange={this.handleInputChange} cols="30" rows="10" placeholder="Paste comma-separated Steam keys here..."></textarea>
          <input className="Button form-submit" disabled={!hasValidKeys || this.props.admin.addingKeys} type="submit" value="Submit" />
        </form>

        {keyInputHelpText}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    admin: state.admin
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(adminActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminKeyPage);



// WEBPACK FOOTER //
// ./src/containers/AdminKeyPage.js